import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback } from 'react';
import { useAIEventsInstrumentation } from '@atlassian/ai-analytics';
import { filterCommonAttributes } from '../../../../ai-answer-dialog/analytics-helpers';
export var SAIN_USAGE_DWELL_THRESHOLD = 3000;
export var SainAction = /*#__PURE__*/function (SainAction) {
  SainAction["SOURCE_CLICKED"] = "sourceLinkClicked";
  SainAction["POSITIVE_FEEDBACK_PROVIDED"] = "positiveFeedbackProvided";
  SainAction["NEGATIVE_FEEDBACK_PROVIDED"] = "negativeFeedbackProvided";
  SainAction["DWELL_REACHED"] = "dwellTimeReached";
  SainAction["COPY_CLICKED"] = "copyButtonClicked";
  SainAction["FOLLOWUP_CLICKED"] = "followupLinkClicked";
  SainAction["OPEN_CHAT_CLICKED"] = "openChatButtonClicked";
  SainAction["EXPAND_CLICKED"] = "expandButtonClicked";
  SainAction["TOPIC_CLICKED"] = "topicClicked";
  SainAction["RECENT_WORK_CLICKED"] = "recentWorkClicked";
  SainAction["COLLABORATOR_CLICKED"] = "collaboratorClicked";
  SainAction["VIEW_PROFILE_CLICKED"] = "viewProfileClicked";
  SainAction["TEAM_MEMBER_CLICKED"] = "teamMemberClicked";
  SainAction["VIEW_TEAM_PAGE_CLICKED"] = "viewTeamPageClicked";
  SainAction["REPORTING_LINES_CLICKED"] = "reportingLinesClicked";
  SainAction["PERSON_SELECTED"] = "cardClicked";
  SainAction["BOOKMARK_CLICKED"] = "bookmarkClicked";
  SainAction["CHAT_CLICKED"] = "chatClicked";
  return SainAction;
}({});
export var useSAINUsageCriteriaMet = function useSAINUsageCriteriaMet() {
  var _useAIEventsInstrumen = useAIEventsInstrumentation(),
    trackAIResultView = _useAIEventsInstrumen.trackAIResultView,
    trackAIResultAction = _useAIEventsInstrumen.trackAIResultAction,
    trackAIFeedbackSubmit = _useAIEventsInstrumen.trackAIFeedbackSubmit;
  var fireSAINUsageEvent = useCallback(function (_ref) {
    var metCriteria = _ref.metCriteria,
      dwellTime = _ref.dwellTime,
      commonAttributes = _ref.commonAttributes;
    var sanitizedCommonAttributes = commonAttributes ? filterCommonAttributes(commonAttributes) : {};
    if (metCriteria) {
      // If usage criteria are provided, emit a viewed event with doesNotMeetMAUCriteria set to false
      trackAIResultView({
        doesNotMeetMAUCriteria: false,
        attributes: _objectSpread({
          dwellTime: dwellTime || 0,
          mauEligibilityCriteria: metCriteria
        }, sanitizedCommonAttributes)
      });
      // In addition, emit an action/feedback event for the action that was met
      // (https://hello.atlassian.net/wiki/x/Vxb5DAE)
      switch (metCriteria) {
        case SainAction.SOURCE_CLICKED:
        case SainAction.COPY_CLICKED:
        case SainAction.FOLLOWUP_CLICKED:
        case SainAction.TOPIC_CLICKED:
        case SainAction.RECENT_WORK_CLICKED:
        case SainAction.COLLABORATOR_CLICKED:
        case SainAction.VIEW_PROFILE_CLICKED:
        case SainAction.TEAM_MEMBER_CLICKED:
        case SainAction.VIEW_TEAM_PAGE_CLICKED:
        case SainAction.OPEN_CHAT_CLICKED:
          trackAIResultAction(metCriteria, {
            attributes: _objectSpread({
              dwellTime: dwellTime
            }, sanitizedCommonAttributes)
          });
          break;
        case SainAction.POSITIVE_FEEDBACK_PROVIDED:
          trackAIFeedbackSubmit('up', {
            attributes: _objectSpread({
              dwellTime: dwellTime
            }, sanitizedCommonAttributes)
          });
          break;
        case SainAction.NEGATIVE_FEEDBACK_PROVIDED:
          trackAIFeedbackSubmit('down', {
            attributes: _objectSpread({
              dwellTime: dwellTime
            }, sanitizedCommonAttributes)
          });
          break;
        default:
          break;
      }
    } else {
      // If no usage criteria are provided, emit a viewed event with doesNotMeetMAUCriteria set to true
      trackAIResultView({
        doesNotMeetMAUCriteria: true,
        attributes: _objectSpread({
          dwellTime: dwellTime || 0
        }, sanitizedCommonAttributes)
      });
    }
  }, [trackAIResultView, trackAIResultAction, trackAIFeedbackSubmit]);
  return {
    fireSAINUsageEvent: fireSAINUsageEvent
  };
};